import Nav from "./mainNavigation";

Nav();

const renderIcons = (icons) =>
  import(/* webpackChunkName: "icons" */ "./icons").then((module) =>
    module.default(icons)
  );

const HomeHero = (hero) =>
  import(/* webpackChunkName: "carousels" */ "./home-hero").then((module) =>
    module.default(hero)
);
HomeHero();

const Carousels = (carousels) =>
  import(/* webpackChunkName: "carousels" */ "./carousels").then((module) =>
    module.default(carousels)
);

const renderMaps = (mapContainers) =>
  import(/* webpackChunkName: "maps" */ "./maps").then((module) =>
    module.default(mapContainers)
  );

const icons = Array.from(document.querySelectorAll("[data-icon]"));

if (icons.length) {
  renderIcons(icons);
}

const carousels = Array.from(document.querySelectorAll(".glide"));

if (carousels.length) {
  Carousels(carousels);
}

const mapContainers = Array.from(document.querySelectorAll(".location__map"));

if (mapContainers.length) {
  renderMaps(mapContainers);
}
